/**
 * Sprint 98 — El contador de pasos, en un solo lugar.
 *
 * ## El defecto que cierra
 *
 * Tres pantallas del mismo flujo se contradecían entre ellas, cada una con su número escrito a
 * mano: `Paso 1 de 4` en los datos del cliente, `Paso 2 de 5` en la dirección, `Paso 3 de 5` en la
 * barra del menú y `Paso 4 de 5` en el envío. Dos denominadores distintos para el mismo camino.
 *
 * Y el "de 5" contaba el cobro, que no es un paso de captura: es lo que pasa **después** de que el
 * pedido ya existe, y por la puerta del cobro se puede entrar sin haber capturado nada.
 *
 * Un número en pantalla que el sistema no puede explicar erosiona la confianza en todos los demás
 * —y los otros números de este sistema son dinero—. Por eso el orden vive aquí y las pantallas lo
 * preguntan en vez de afirmarlo.
 */
/**
 * Sprint 98 — Tres, no cuatro.
 *
 * `donde` dejó de ser un paso: quien contesta el teléfono pregunta *"¿quién habla y a dónde es?"*
 * en la misma respiración, así que la dirección se captura junto con el cliente (`QuienYADondeForm`).
 * Se conserva el orden que importa —la dirección **antes** del menú, para no capturar la comida y
 * descubrir después que no se llega hasta allá—, pero ya no cuesta una pantalla.
 */
export const PASOS_DOMICILIO = ['cliente', 'menu', 'envio'] as const;

export type PasoDomicilio = (typeof PASOS_DOMICILIO)[number];

export const TOTAL_PASOS_DOMICILIO = PASOS_DOMICILIO.length;

/**
 * "Paso 2 de 4" para las fases del camino; `null` para todo lo demás (mesa, tipo, cobro).
 *
 * Devuelve `null` en vez de inventar un número: una fase que no es del camino no tiene por qué
 * fingir que lo es.
 */
export function etiquetaPaso(fase: string): string | null {
  const indice = PASOS_DOMICILIO.indexOf(fase as PasoDomicilio);
  if (indice < 0) return null;
  return `Paso ${indice + 1} de ${TOTAL_PASOS_DOMICILIO}`;
}
